import cn from "classnames";
import { Chip } from "@/components/chip/chip.component";
import { ProductTileProduct } from "./productTile.component";
import { ProductTileTagsLoading } from "./productTileTagsLoading.component";

export const ProductTileTags = ({ product, loading }: ProductTileTagsProps) => {
  const renderProductTags = () => {
    if (!product?.tags?.length) return null;
    const mobileLimit = 3;
    const hiddenCount = product?.tags?.length - mobileLimit;
    return (
      <div
        className="flex flex-wrap items-center gap-2"
        data-testid="product-tile-tags-list">
        {product?.tags?.map((tag, index) => (
          <Chip
            key={tag}
            label={tag}
            variant="tertiary"
            className={cn(
              "body-4",
              index >= mobileLimit && "hidden md:inline-flex",
            )}
          />
        ))}
        {/* On mobile, show the hidden count */}
        {hiddenCount > 0 && (
          <Chip
            label={`+${hiddenCount}`}
            variant="tertiary"
            className={cn("body-4", "md:hidden")}
          />
        )}
      </div>
    );
  };

  if (loading) return <ProductTileTagsLoading />;
  return (
    <div
      className="flex flex-wrap items-center gap-2"
      data-testid="product-tile-tags">
      {renderProductTags()}
    </div>
  );
};

export type ProductTileTagsProps = {
  product?: ProductTileProduct;
  loading?: boolean;
};
